import ashe from './ashe.png';

const AsheLogo = (): JSX.Element => (
    <img alt="ASHE Optimizing health care facilities" src={ashe} />
);

export default AsheLogo;